import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UserManager } from 'oidc-client';
import { RedirectingMessage } from './login_check.styles';
import { ConfigContext } from '@amzn/aapn-front-end-config-lib';
import { verifyUser } from './login_check.code';
export const UserContext = React.createContext(undefined);
export const LoginCheck = (param) => {
    const config = useContext(ConfigContext);
    const [user, setUser] = useState();
    const history = useHistory();
    const userManager = new UserManager({
        authority: config.authAuthority,
        client_id: config.authClientId,
        redirect_uri: config.authRedirectUrl,
    });
    verifyUser(userManager, history.location.pathname + history.location.search, user, (user) => {
        setUser(user);
        history.replace(user.state || '/');
    })();
    if (user) {
        return React.createElement(UserContext.Provider, { value: user }, param.children);
    }
    else {
        return React.createElement(RedirectingMessage, null, "Logging in...");
    }
};
